export default "__VITE_ASSET__BfpSpd6n__"